/**
 * @fileoverview This file contains the class to expose various inventory utilities methods.
 *
 * @version 1.0.0
 * @since 1.0.0
 * @author Santiago Cano Herrera
 */

/**
 * Utility class for inventory-related operations.
 */
class InventoryUtils {
  /**
   * Determines the stock color based on the current stock level.
   *
   * @param {number} minStock - The minimum stock threshold.
   * @param {number} maxStock - The maximum stock threshold.
   * @param {number} currentStock - The current stock level.
   * @returns {string} The color code representing the stock level.
   */
  static getStockColor(minStock, maxStock, currentStock) {
    const lowThreshold = minStock;
    const middleThreshold = maxStock * 0.6;
    const highThreshold = maxStock * 0.8;

    if (currentStock <= lowThreshold) {
      return '#F8463B'; // Red for low stock
    } else if (currentStock > lowThreshold && currentStock < middleThreshold) {
      return '#FC842D'; // Orange for medium-low stock
    } else if (
      currentStock >= middleThreshold &&
      currentStock < highThreshold
    ) {
      return '#000000'; // Black for medium-high stock
    } else {
      return '#52B442'; // Green for high stock
    }
  }
}

export default InventoryUtils;
